import { render, staticRenderFns } from "./addsuccess.vue?vue&type=template&id=1b019028&"
import script from "./addsuccess.vue?vue&type=script&lang=js&"
export * from "./addsuccess.vue?vue&type=script&lang=js&"
import style0 from "./addsuccess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports